export default __webpack_public_path__ + "static/media/Transaction-restrictions.c795c058.svg";